<template>
  <router-view />
  <ToastNotification />
</template>

<script>
import ToastNotification from './containers/ToastNotification.vue'

export default {
  name: 'App',
  components: { ToastNotification }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
